import TextSnippetIcon from '@mui/icons-material/TextSnippet';

import { SpeedDial } from '../../../components/SpeedDial';
import { PATH_DOCUMENT_TEMPLATES_NEW_DEFAULT } from '../../../app/constants/paths.constant';

import { DocumentTemplatesList } from './List';

export const DocumentTemplatesTabPanel = () => (
  <>
    <DocumentTemplatesList />
    <SpeedDial
      actions={[
        {
          id: 'createDocumentTemplate',
          icon: <TextSnippetIcon />,
          name: 'Créer Modèle Document',
          to: PATH_DOCUMENT_TEMPLATES_NEW_DEFAULT,
        },
      ]}
      title="Actions possibles sur les Modèles"
    />
  </>
);
